angular.module("registrationModule").component("registrationThankYou", {
	templateUrl: "registrationThankYou/registrationThankYou.html",
	bindings: {
		onValidatePhone: "&",
		onSubmit: "&",
		onClose: "&",
		user: "<",
		errorMessages: "<",
		version: "<",
		adDesignVersion: "<",
		adDesignEnabled: "<",
		buildingNameOrAddress: "<",
		calloutBoxType: '<',
		calloutBoxSourcePage: '<',
		messageIsClear: "<",
		interest: "<"
	},
	controller: ["$document", "$timeout", "$element", function($document, $timeout, $element) {
		var self = this;

		//this.interest = "lookingToBuy";

		this.triedToSubmit = false;
		this.offMarketListings    = false;
		this.newDevelopmentDeals  = false;
		this.sellingYourApartment = false;
		this.workingWithAnAgent   = false;
		this.marketInsightAndData = false;
		this.infoFor1stTimeBuyers = false;
		this.virtualToursOfNoFee = false;
		//this.interest = "lookingToRent";

		this.user.emailUpdates = true;

		if (!!this.calloutBoxType) {
			if (this.calloutBoxType === 'new-dev-deals') {
				this.newDevelopmentDeals = true;
			}
			if (this.calloutBoxType === 'off-market-deals') {
				this.offMarketListings = true;
			}
		}

		this.resourcesPath = Res_i;

		this.$onInit = () => {
			this.checkboxesLookingTo = this.getLookingToCheckboxes();
			this.checkboxesInterestedInOffMarketListings = this.getInterestedInOffMarketListingsCheckboxes();
			this.checkboxesWhenToMove = this.getWhenToMoveCheckboxes();
			this.checkboxesListedForSaleOrRent = this.getListedForSaleOrRentCheckboxes();
			this.checkboxesInterest = this.getInterestCheckboxes();
			this.checkboxesSingleOption = this.getSingleOptionCheckboxes();

			$timeout(() => {
				if(this.adDesignEnabled != '1' || this.adDesignVersion == 'B') this.form['lookingToBuy'] = true; // default value is looking to buy
			});

			this.shuffleArray(this.checkboxesInterest);
		};

		this.$postLink = function() {
		};

		this.shuffleArray = (array) => {
			for (let i = array.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[array[i], array[j]] = [array[j], array[i]];
			}
		};

		this.toggleValue = function (checkbox) {
			let checkboxes = [...this.checkboxesInterest, ...this.checkboxesSingleOption, ...this.checkboxesLookingTo, ...this.checkboxesInterestedInOffMarketListings, ...this.checkboxesWhenToMove, ...this.checkboxesListedForSaleOrRent];
			let checkboxToToggle = checkboxes.find(cb => {
				return checkbox.id === cb.id;
			});

			let checkboxesToCycleThrough = [this.checkboxesLookingTo, this.checkboxesInterestedInOffMarketListings, this.checkboxesWhenToMove, this.checkboxesListedForSaleOrRent];
			checkboxesToCycleThrough.forEach(function (checkboxesObject) {
				if(!checkboxesObject) return
				let pos = checkboxesObject.map(function(e) { return e.id; }).indexOf(checkboxToToggle.id);
				if (pos >= 0) {
					checkboxesObject.forEach(function(e) {
						self.form[e.id] = e.value = false;
					});
				}
			});

			checkboxToToggle.value = !checkboxToToggle.value;
			this.form[checkbox.id] = checkbox.value;
			if (checkboxToToggle.id === 'offMarketListings') {
				this.offMarketListings = checkboxToToggle.value;
			}
			if (checkboxToToggle.id === 'newDevelopmentDeals') {
				this.newDevelopmentDeals = checkboxToToggle.value;
			}
		};

		this.submit = function() {
			this.triedToSubmit = true;

			if (typeof this.form.phone !== "undefined") {
				this.form.phone.interacted = false;
			}

			if (this.offMarketListings === true) {
				this.form.offMarketListings = true;
			}
			if (this.newDevelopmentDeals === true) {
				this.form.newDevelopmentDeals = true;
			}
			if (this.canSubmit()) {
				this.onSubmit({form: this.form});
			} else {
				this.form.$submitted = true;
			}
		};

		this.canSubmit = function() {
			return !this.isWhenToMoveChoiceExpected()
				&& !this.isBudgetInputExpected()
				&& !this.isLookingToExpected()
				&& !this.isInterestedInExpected()
				&& !this.isTextAreaInputExpected()
				&& !this.isAddressInputExpected()
				&& !this.isCurrentlyListedInputExpected()
				&& this.form.$valid
		};

		this.validatePhone = function(phone, form, callback) {
			this.onValidatePhone({phone: phone, form: form, callback: callback});
		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		// the following .is* functions are for the newer design (user coming from google ads, CITY-3398)
		this.isBuyingSelected = function() {
			return this.adDesignEnabled === "1" && this.adDesignVersion != 'B' && this.interest == "lookingToBuy";
		};

		this.isRentingSelected = function() {
			return this.adDesignEnabled === "1" && this.adDesignVersion != 'B' && this.interest == "lookingToRent";
		};

		this.isSellingSelected = function() {
			return this.adDesignEnabled === "1" && this.adDesignVersion != 'B' && this.interest == "lookingToSell";
		};

		this.isOtherSelected = function() {
			return this.adDesignEnabled === "1" && this.adDesignVersion != 'B' && this.interest == "lookingToNeither";
		};

		this.isWhenToMoveChoiceExpected = function() {
			return (
				this.isRentingSelected() &&
				typeof(this.form["movingIn30Days"]) === "undefined" &&
				typeof(this.form["movingInFewMonths"]) === "undefined" &&
				typeof(this.form["movingNotSure"]) === "undefined"
			);
		};

		this.isBudgetInputExpected = function() {
			return this.isRentingSelected() && (typeof(this.form["budget"]) === "undefined" || !this.form["budget"].$modelValue);
		};

		this.isAddressInputExpected = function () {
			return false;
			// if (this.buildingNameOrAddress) {
			// 	return false;
			// }
			// return this.isSellingSelected() && (typeof(this.form["address"]) === "undefined" || !this.form["address"].$modelValue);
		};

		this.isCurrentlyListedInputExpected = function () {
			return false;
			// return (
			// 	this.isSellingSelected() &&
			// 	typeof(this.form["listedForSaleOrRentYes"]) === "undefined" &&
			// 	typeof(this.form["listedForSaleOrRentNo"]) === "undefined"
			// )
		}

		this.isTextAreaInputExpected = function () {
			return !this.isSellingSelected() && (typeof(this.form["message"]) === "undefined" || !this.form["message"].$modelValue);
		};

		this.isLookingToExpected = function () {
			return false; // it's set to lookingToBuy:true by default;
			// if (!this.checkboxesLookingTo) return false;
			// for(let i = 0; i < this.checkboxesLookingTo.length; i++) {
			// 	if (this.checkboxesLookingTo[i].value) {
			// 		return false;
			// 	}
			// }
			// return true;
		};

		this.isInterestedInExpected = function () {
			return false;
			// if (this.adDesignEnabled === "1") return false;
			// for(let i = 0; i < this.checkboxesInterest.length; i++) {
			// 	if (this.checkboxesInterest[i].value) {
			// 		return false;
			// 	}
			// }
			// return true;
		};

		this.isMessageClear = function() {
			return this.messageIsClear;
		};

		this.toggleEmailUpdates = function() {
			this.user.emailUpdates = !this.user.emailUpdates;
		};

		this.fieldChange = function(key) {
			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};

		this.getInterestedInTitleText = function() {
			if (this.adDesignEnabled === "1" && this.adDesignVersion != 'B') {
				return "What are you interested in?";
			} else {
				return "Are you looking to buy or rent?";
			}
		};

		this.getTextAreaTitleText = function () {
			if (this.adDesignVersion == 'B') {
				return "What are you looking for? When's good for a tour?";
			}
			if (this.isBuyingSelected()) {
				return "Tell us a bit about what you are looking for and when you want to view apartments:";
			} else if (this.isRentingSelected()) {
				return "Tell us a bit about what you are looking for and when you want to view apartments:";
			} else if (this.isSellingSelected()) {
				return "Is there anything about your apartment that you would like to share?";
			} else if (this.isOtherSelected()) {
				return "Please tell us a bit about what you are looking for:";
			} else {
				return "Please tell us a bit about what you are looking for:";
			}
		};

		this.getTextAreaPlaceHolderText = function() {
			if (this.adDesignVersion == 'B') {
				return "For example: 2 bed with views for $4M to view next weekend.";
			}
			if (this.isBuyingSelected()) {
				return "ex. 2 bed to view tomorrow";
			} else if (this.isRentingSelected()) {
				return "ex. 2 bed to view tomorrow";
			} else if (this.isSellingSelected()) {
				return "ex. high end appliances included";
			} else if (this.isOtherSelected()) {
				return "ex. 2 bed with a view";
			} else {
				return "ex. 2 bed condo in West Village";
			}
		};

		this.getInterestedInOffMarketListingsCheckboxes = function() {
			return [{
				id: "offMarketListingsYes",
				value: false,
				label: "Yes",
			}, {
				id: "offMarketListingsNo",
				value: false,
				label: "No thanks",
			}];
		};

		this.getWhenToMoveCheckboxes = function() {
			return [{
				id: "movingIn30Days",
				value: false,
				label: "Next 30 days",
			}, {
				id: "movingInFewMonths",
				value: false,
				label: "Few months",
			}, {
				id: "movingNotSure",
				value: false,
				label: "Not sure"
			}];
		};

		this.getListedForSaleOrRentCheckboxes = function() {
			return [{
				id: "listedForSaleOrRentYes",
				value: false,
				label: "Yes",
			}, {
				id: "listedForSaleOrRentNo",
				value: false,
				label: "No",
			}];
		};

		this.getLookingToCheckboxes = function() {
			if (this.adDesignEnabled !== "1" || this.adDesignVersion == 'B') {
				return [
					{
						id: "lookingToBuy",
						value: true,
						label: "To Buy",
					},
					{
						id: "lookingToRent",
						value: false,
						label: "To Rent",
					},
					{
						id: "lookingToSell",
						value: false,
						label: "To Sell",
					},
					{
						id: "lookingToNeither",
						value: false,
						label: "Other",
					}
				];
			} else {
				return false;
			}
		};

		this.getInterestCheckboxes = function() {
			return [{
				id: "offMarketListings",
				value: this.offMarketListings,
				label: "Off-market\nListings",
			}, {
				id: "newDevelopmentDeals",
				value: this.newDevelopmentDeals,
				label: "New Development Deals",
			}, {
				id: "sellingYourApartment",
				value: false,
				label: 'Selling\na Property',
			}, {
				id: "marketInsightAndData",
				value: false,
				label: "Market Insight and Data",
			}, {
				id: "infoFor1stTimeBuyers",
				value: false,
				label: "Info for First Time Buyers",
			}, {
				id: "investmentProperties",
				value: false,
				label: "Investment Properties",
			}];
		};

		this.getSingleOptionCheckboxes = function () {
			if (this.adDesignVersion == 'B' && this.buildingNameOrAddress) {
				return [{
					id: "speakWithAnExpert",
					value: false,
					label: "I'd like to speak with an expert to help find an apartment at " + this.buildingNameOrAddress,
				}];
			}
			return [{
				id: "speakWithAnExpert",
				value: false,
				label: "I'd like to speak with an expert to help find an apartment",
			}];
		}
	}]
});
